import React from 'react';
import { useDispatch } from 'react-redux';

import { Grid, Switch, Typography, makeStyles } from '@material-ui/core';

import { putSubAreasFisicasAction } from '../../../actions/usuarios/areasFisicas';

const useStyles = makeStyles({
    root:{
        background:'#212121'
    },
    TypographyRoot:{
        color:'white'
    },
    switchBase:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
              backgroundColor: '#3E8040',
              opacity: 1,
              border: 'none',
            },
          },
    },
    switchBase2:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#ffee58',
            '& + $track': {
              backgroundColor: '#B7A931',
              opacity: 1,
              border: 'none',
            },
          },
    },
    checked:{},
    track: {},
    swithColorPrimary:{
        color: 'yellow'
    }
});

export const SubAreaFisica = ({subArea, values, setearValores}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const subAreaSelected = subArea.idSubArea === values.idSubArea;

    return (
        <>
        <Grid item xs={3} md={1}>
            <Switch
                checked={subAreaSelected}
                onChange={() => {
                dispatch(putSubAreasFisicasAction({...values, ...subArea}, setearValores, values));
                }}
                color="primary"
                classes={{switchBase:classes.switchBase,checked:classes.checked,track:classes.track}}
            />
            </Grid>
            <Grid item xs={9} md={5}>
            <Typography className={classes.TypographyRoot}>{`${subArea.descripcionSubArea}`}</Typography>
        </Grid>
        </>
    )
}

